export const emailChangedCheck = (formData, user, userInfo) => {
  return (
    formData.emailAddress !== user?.emailId ||
    formData.emailAddress !== userInfo?.email?.address
  );
};

export const phoneNumberChangedCheck = (formData, userInfo) => {
  // lifeSys does not format phoneNumber so we need to strip it before comparing
  return (
    formData?.phoneNumber?.replace(/[^\d]/g, "") !==
    userInfo?.phone?.phoneNumber
  );
};

export const addressChangedCheck = (formData, userInfo) => {
  return (
    formData.addressLine1 !== userInfo?.address?.addressLine1 ||
    formData.addressLine2 !== userInfo?.address?.addressLine2 ||
    formData.city !== userInfo?.address?.city ||
    formData.state !== userInfo?.address?.state ||
    formData.postalCode !== userInfo?.address?.postalCode.substring(0, 5)
  );
};
